import { Grid, Typography } from "@mui/material";
import AutoComplete, { OptionType } from "../../../components/AutoComplete";
import FormButtons from "../../../components/FormButtons";
import FormContainer from "../../../components/FormContainer";
import InputCounter from "../../../components/input/InputCounter";
import InputField from "../../../components/input/InputField";
import InputCalendrier from "../../../components/inputCalendrier/InputCalendrier";
import Select from "../../../components/select/Select";
import { maskNumTelephone } from "../../../helpers/formatters";
import { getTitleCandidat } from "../../../helpers/utils";
import Libelles from "../../../_i18n/fr.json";
import {
  maxEnfantsAge,
  maxLocataireAge,
  minEnfantsAge,
  minLocataireAge,
} from "../../../helpers/validators";

import { AnyObject, Field } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";
import { useNavigate } from "react-router";
import Libelle from "../../../_i18n/fr.json";
import InputRadio from "../../../components/inputRadio/InputRadio";
import {
  Commune,
  DossierLocation,
  TypeVoie,
} from "../../../services/Api/swagger";
import { construireTypeVoieOptions } from "../BienPage/helpers";
import ConjointForm from "./conjointForm";
import { buildCompositionLocation, SituationPersonnelleForm } from "./helpers";

interface Props {
  listTypeVoie?: TypeVoie[];
  dossierLocation?: DossierLocation;
  statutOccupation: { key: string; value: string; text: string }[];
  listSituations?: { key: string; value: string; text: string }[];
  qualites: { key: string; value: string; text: string }[];
  formErrors?: any;
  isFetching: boolean;
  classes?: any;
  onChangeCommune?(commune: Commune): void;
  communes?: OptionType[];
  selectedDossier?: string;
  selectedPerson?: string;
  onSubmit: (
    event?: Partial<
      Pick<React.SyntheticEvent, "preventDefault" | "stopPropagation">
    >
  ) => Promise<AnyObject | undefined> | undefined;
  values: SituationPersonnelleForm;
  push(param: string, value: any): void;
  pop(param: string): void;
  isFetchingSearchPostCode?: boolean;
}

function SituationPersonnelleFormPage({
  listTypeVoie,
  statutOccupation,
  qualites,
  dossierLocation,
  isFetching,
  selectedDossier,
  selectedPerson,
  onSubmit,
  communes,
  onChangeCommune,
  listSituations,
  values,
  push,
  pop,
  isFetchingSearchPostCode,
}: Props) {
  const navigate = useNavigate();

  const handlePrecedent = () => {
    navigate("/dossier-location/bien");
  };

  const increment = (values: SituationPersonnelleForm) => {
    // if (values && values.enfants) {
    //   const enfants = values.enfants;
    //   push("enfants", { dateNaissance: "" }, enfants.length);
    // } else if (values) {
    //   push("enfants", { dateNaissance: "" }, 0);
    // }
    push("enfants", { dateNaissance: "" });
  };

  const decrement = (values: SituationPersonnelleForm) => {
    // if (values && values.enfants) {
    //   const enfants = values.enfants;
    //   pop("enfants", enfants.length - 1);
    // } else if (values) {
    //   pop("enfants", 0);
    // }
    pop("enfants");
  };

  const listVoies = listTypeVoie && construireTypeVoieOptions(listTypeVoie);
  const nombreEnfants = (values: SituationPersonnelleForm) => {
    return values && values.enfants ? values.enfants.length : 0;
  };

  return (
    <>
      <h5 className="titlePage">
        {dossierLocation &&
          values &&
          getTitleCandidat(
            dossierLocation,
            values.typeCompte,
            dossierLocation.dossiersParticuliers,
            values.refDossierLocataire || undefined,
            selectedPerson || undefined,
            undefined
          )}
      </h5>
      <form onSubmit={onSubmit} noValidate>
        {values.principal && (
          <>
            {/* <h3>{Libelle.pageSituationPerso.sections.section0}</h3> */}
            <FormContainer>
              <Grid container>
                <Grid item xs={12}>
                  <Field
                    name="compositionLocation"
                    component={InputRadio}
                    items={buildCompositionLocation()}
                    label="Type de location"
                    required
                  />
                </Grid>
              </Grid>
              <Typography variant="caption">
                {Libelles.typeDossierCouple}
              </Typography>
            </FormContainer>
          </>
        )}
        <h3>
          {
            Libelle.pageSituationPerso.sections[
              values && values.typeCompte === "GARANT"
                ? "sectionGarant"
                : "section1"
            ]
          }
        </h3>
        <FormContainer>
          <Grid container spacing={2}>
            <Grid item>
              <Field
                name="qualite"
                component={Select}
                options={qualites}
                label="Qualité"
                required
              />
            </Grid>
            <Grid item>
              <Field
                name="nom"
                component={InputField}
                label="Nom"
                maxLength={29}
                required
              />
            </Grid>
            <Grid item>
              <Field
                name="nomDeNaissance"
                component={InputField}
                label="Nom de naissance"
                maxLength={29}
                note="(si différent du nom d'usage)"
              />
            </Grid>
            <Grid item>
              <Field
                name="prenom"
                component={InputField}
                label="Prénom"
                maxLength={29}
                required
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item>
              <Field
                name="dateNaissance"
                component={InputCalendrier}
                label="Date de naissance"
                required
                variante="inline"
                varianteInput="filled"
                minDate={maxLocataireAge}
                maxDate={minLocataireAge}
              />
            </Grid>
            <Grid item>
              <Field
                name="email"
                component={InputField}
                label="Mail"
                required
              />
            </Grid>
            <Grid item>
              <Field
                name="telephoneFixe"
                component={InputField}
                label="Fixe"
                mask={maskNumTelephone()}
              />
            </Grid>
            <Grid item>
              <Field
                name="telephonePortable"
                component={InputField}
                label="Mobile"
                mask={maskNumTelephone()}
                required
              />
            </Grid>
          </Grid>
        </FormContainer>

        <h3>{Libelle.pageSituationPerso.sections.section2}</h3>
        <FormContainer>
          <Grid container spacing={2}>
            <Grid item>
              <Field
                name="dateEntree"
                component={InputCalendrier}
                isYear={true}
                type="date"
                label="Date d'entrée"
                placeholder="Date d'entrée"
                variante="inline"
                varianteInput="filled"
                minDateMessage="Merci de vérifier la date d'entrée"
                maxDateMessage="La date d'entrée doit être inférieure à la date du jour"
                invalidDateMessage="Merci de vérifier la date d'entrée"
              />
            </Grid>
            <Grid item>
              <Field
                name="statutOccupation"
                component={Select}
                options={statutOccupation}
                label="Statut"
                required
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={2}>
              <Field
                name="numero"
                component={InputField}
                label="Numéro"
                type="text"
                maxLength={10}
              />
            </Grid>

            <Grid item>
              <Field
                name="typeVoie"
                component={Select}
                options={listVoies}
                label="Type de voie"
                required
              />
            </Grid>
            <Grid item xs={4}>
              <Field
                name="adresse"
                component={InputField}
                label="Nom de la voie"
                maxLength={40}
                required
              />
            </Grid>
            <Grid item xs={2}>
              <Field
                name="numeroBatiment"
                component={InputField}
                label="N° de bâtiment"
                maxLength={4}
              />
            </Grid>
          </Grid>
          <Grid item>
            <Field
              name="codePostalVille"
              required
              component={AutoComplete}
              fetchOptions={onChangeCommune}
              loading={isFetchingSearchPostCode}
              label={"Code postal / ville"}
              getOptions={communes || []}
            />
          </Grid>
        </FormContainer>
        {values &&
          values.compositionLocation === "COUPLE" &&
          values &&
          values.typeCompte !== "GARANT" &&
          qualites && <ConjointForm qualites={qualites} />}
        <h3>{Libelle.pageSituationPerso.sections.section4}</h3>
        <FormContainer>
          <Grid container spacing={2}>
            <Grid item>
              <Field
                name="situationMaritale"
                component={Select}
                options={listSituations}
                type="text"
                label="Situation Maritale"
                required
              />
            </Grid>

            <Grid item>
              <InputCounter
                label="Nombre d’enfants à charge figurant sur l’avis d’imposition"
                minValue={0}
                maxValue={10}
                onIncrement={() => increment(values)}
                onDecrement={() => decrement(values)}
                initialValue={nombreEnfants(values)}
                required
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <FieldArray name="enfants">
              {({ fields }) =>
                fields.map((item, index) => {
                  return (
                    <Grid item key={index}>
                      <Field
                        name={`${item}.dateNaissance`}
                        component={InputCalendrier}
                        label={"Enfant n°" + (index + 1) + " né(e) le"}
                        variante="inline"
                        varianteInput="filled"
                        minDate={maxEnfantsAge}
                        maxDate={minEnfantsAge}
                        required
                        isYear
                      />
                    </Grid>
                  );
                })
              }
            </FieldArray>
          </Grid>
        </FormContainer>
        <FormButtons
          onPrecedent={handlePrecedent}
          fetching={isFetching}
          canCancel={dossierLocation?.reference}
        />
      </form>
    </>
  );
}

export default SituationPersonnelleFormPage;
